import React, { useEffect, useState } from 'react';
import './StudentMobileBottomNav.css';

// Order chosen so Home sits in the centre (position 3 of 5) — that's
// the most ergonomic slot for the primary destination on a mobile
// bottom tab bar.
const items = [
  {
    name: 'dictionary',
    label: 'Dictionary',
    icon: (
      <svg width="22" height="22" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>
      </svg>
    ),
  },
  {
    name: 'homework',
    label: 'Homework',
    icon: (
      <svg width="22" height="22" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V19a2 2 0 0 1-2 2Z"/>
      </svg>
    ),
  },
  {
    name: 'home',
    label: 'Home',
    icon: (
      <svg width="22" height="22" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
          d="m4 12 8-8 8 8M6 10.5V19a1 1 0 0 0 1 1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 0 1-1v-8.5"/>
      </svg>
    ),
  },
  {
    name: 'chat',
    label: 'Chat',
    isChat: true,
    // Same "chat bubble face" icon as the floating .student-chat-fab
    // button this tab replaces, for visual continuity.
    icon: (
      <svg width="22" height="22" fill="currentColor" viewBox="0 0 16 16">
        <path d="M16 8c0 3.866-3.582 7-8 7a9 9 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7M5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
      </svg>
    ),
  },
  {
    name: 'profile',
    label: 'Profile',
    icon: (
      <svg width="22" height="22" fill="none" viewBox="0 0 24 24">
        <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2"/>
        <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" d="M4 21c0-4 4-7 8-7s8 3 8 7"/>
      </svg>
    ),
  },
];

export default function StudentMobileBottomNav({ activeSection, onSectionChange, onChatClick, newHomeworkCount = 0, avatarUrl = null }) {
  // Hide inside lesson view — lesson has its own bottom tab bar
  const isInLesson = activeSection === 'lesson';

  // Instagram-style shrink-on-scroll-down / grow-on-scroll-up. This
  // dashboard scrolls the window/document itself (.student-dashboard-
  // main has no overflow of its own), unlike the teacher app's
  // .main-content-area — so the listener goes on window.
  const [compact, setCompact] = useState(false);
  useEffect(() => {
    let lastY = window.scrollY;
    let raf = null;
    const onScroll = () => {
      if (raf !== null) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        const y = window.scrollY;
        const dy = y - lastY;
        if (Math.abs(dy) > 4) {
          setCompact(dy > 0 && y > 24);
          lastY = y;
        }
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (raf !== null) cancelAnimationFrame(raf);
    };
  }, []);

  if (isInLesson) return null;

  return (
    <nav className={`student-mobile-bottom-nav${compact ? ' is-compact' : ''}`} aria-label="Student navigation">
      {items.map(item => (
        <button
          key={item.name}
          className={'student-mobile-bottom-nav-link' + (!item.isChat && activeSection === item.name ? ' active' : '')}
          onClick={() => (item.isChat ? onChatClick?.() : onSectionChange(item.name))}
          aria-label={item.label}
        >
          <span className="student-mobile-bottom-nav-icon">
            {item.name === 'profile' && avatarUrl ? (
              <img src={avatarUrl} alt="" className="student-mobile-bottom-nav-avatar" />
            ) : item.icon}
            {item.name === 'homework' && newHomeworkCount > 0 && (
              <span className="student-mobile-bottom-nav-badge">
                {newHomeworkCount > 9 ? '9+' : newHomeworkCount}
              </span>
            )}
          </span>
        </button>
      ))}
    </nav>
  );
}
